import { json, useNavigate, useLoaderData } from "react-router-dom";
import { get, patch } from "../apiClient";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { Box, Button } from "@mui/material";
import useTitle from "../hooks/useTitle";
import { useScrollToTop } from "../hooks/useScrollToTop";
import DistributorStatusSection from "./../features/programmatic_supply/DistributorStatusSection";
import DistributorBiddersSection from "./../features/programmatic_supply/DistributorBiddersSection";
import DistributorCustomBidfloorSection from "./../features/programmatic_supply/DistributorCustomBidfloorSection";
import DistributorPlacementTargetingsSection from "./../features/programmatic_supply/DistributorPlacementTargetingsSection";

const loader = async ({ params, request }) => {
  try {
    const distributor = await get(
      "player",
      `/api/programmatic_supply/distributors/${params.id}`,
      { signal: request.signal }
    );

    return distributor;
  } catch (error) {
    throw json(
      {
        title: "There was an error fetching the distributor settings from the server",
        text: " Please try again. If the error is persistent, contact support.",
      },
      { status: error.status }
    );
  }
};

const splitList = (str) => str.length === 0 ? [] : str.split(",")

const action = async ({ params, request }) => {
  const formData = await request.formData();
  const { placement_ids, bidder_ids, ...payload } = Object.fromEntries(formData);

  try {
    const distributor = await patch(
      "player",
      `/api/programmatic_supply/distributors/${params.id}`,
      {
        ...payload,
        ...(placement_ids !== undefined && { placement_ids: splitList(placement_ids) }),
        ...(bidder_ids !== undefined && { bidder_ids: splitList(bidder_ids) }),
      },
      { signal: request.signal }
    );

    return distributor
  } catch (error) {
    switch(error.status) {
      case 400:
      case 422:
        return json(error.details, { status: error.status });
      default:
        /* istanbul ignore next */
        throw error;
    }
  }
}

const ProgrammaticSupplyDistributor = () => {
  const distributor = useLoaderData();
  const navigate = useNavigate();
  useTitle("Programmatic Supply Configuration > Publisher Configuration");
  useScrollToTop();

  return (
    <>
    <Box sx={{ display: "flex", flexDirection: "row", pb: 2 }}>
    <Button
    startIcon={<KeyboardArrowLeftIcon />}
    onClick={() => navigate("/programmatic_supply/distributors")}
    >
    Back
    </Button>
    </Box>
    <DistributorStatusSection distributor={distributor} />
    <DistributorCustomBidfloorSection distributor={distributor} />
    <DistributorBiddersSection distributor={distributor} />
    <DistributorPlacementTargetingsSection distributor={distributor} />
    </>
  );
};

export { loader, action };

export default ProgrammaticSupplyDistributor;
